import React, { useState } from 'react';
import DonutChart from '../DonutChart';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ActualVsForecastRevenueChart = () => {
  const [focusMode, setFocusMode] = useState(false);

  const revenueData = {
    label: ['Actual Revenue', 'Forecast Revenue'],
    series: [75, 25],
  };

  return (
    <>
      {/* Card View */}
      <div className="bg-white p-6 rounded-xl shadow-md relative">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800 text-center w-full">
            Actual vs Forecast Revenue
          </h3>
          <button
            onClick={() => setFocusMode(true)}
            className="absolute top-4 right-4 text-sm px-3 py-1.5 rounded-md bg-[#1A2B5C] text-white hover:bg-[#EE1D23] transition"
          >
            Focus Mode
          </button>
        </div>
        <DonutChart data={revenueData} />
      </div>

      {/* Focus Mode Overlay */}
      {focusMode && (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="relative w-full max-w-3xl bg-white rounded-3xl p-8 shadow-2xl overflow-y-auto max-h-[90vh]">
            <button
              onClick={() => setFocusMode(false)}
              className="absolute top-4 right-4 bg-white rounded-full shadow p-2 hover:text-[#EE1D23] transition"
              title="Exit Focus Mode"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-center text-[#1A2B5C]">
              Actual vs Forecast Revenue (Focus Mode)
            </h2>
            <DonutChart data={revenueData} />
            <div className="mt-6 flex justify-around">
              <div className="text-center">
                <p className="text-gray-500 text-sm">Actual Revenue</p>
                <p className="text-lg font-bold text-green-700">75%</p>
              </div>
              <div className="text-center">
                <p className="text-gray-500 text-sm">Forecast Revenue</p>
                <p className="text-lg font-bold text-blue-700">25%</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActualVsForecastRevenueChart;
